import React from 'react';
import PropTypes from 'prop-types';
import { replaceTextWithValues } from 'src/common/utils/text-replace';
import './OrderDelivery.scss';

const OrderDelivery = ({ label, delivery }) => (
  <div className="order-delivery">
    {replaceTextWithValues(label, delivery)}
  </div>
);

OrderDelivery.propTypes = {
  label: PropTypes.string.isRequired,
  delivery: PropTypes.shape({
    latest: PropTypes.string.isRequired,
    earliest: PropTypes.string.isRequired
  }).isRequired,
};

export default OrderDelivery;



// WEBPACK FOOTER //
// ./src/client/js/view/components/Order/OrderDelivery/OrderDelivery.js